import { Divider } from 'antd';
import React from 'react';
import styles from './style.module.scss';

const CustomDivider = () => <Divider className={styles.dividerCustom} />;

export default CustomDivider;
